import { useCallback, useEffect, useRef } from 'react';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { checkHasCookieConsent } from 'hb-react/shared/apps/CookieBanner/utils/amplitude/cookieUtils';
import { connectAmplitude } from 'hb-react/shared/apps/CookieBanner/utils/amplitude/identifyUtils';

export const useConnectAmplitude = (env: 'bo' | 'fo' | 'po') => {
  const { currentNetwork, currentUser, currentAdmin } = useDefaultAppContexts();
  const isConnectedRef = useRef(false);
  const amplitudeIsEnabled =
    currentNetwork?.features?.amplitude?.config.amplitude_enabled;
  const cookieBannerEnabled =
    currentNetwork.features.cookies.config.display_cookie_agreement;

  const connect = useCallback(() => {
    isConnectedRef.current = true;
    connectAmplitude({
      currentNetwork,
      currentUser,
      currentAdmin,
    });
  }, [currentNetwork, currentUser, currentAdmin]);

  useEffect(() => {
    if (!isConnectedRef.current) {
      const hasCookieConsent = checkHasCookieConsent({
        cookieBannerEnabled,
        amplitudeIsEnabled,
        env,
      });

      if (hasCookieConsent) {
        connect();
      }
    }
  }, [cookieBannerEnabled, amplitudeIsEnabled, env, connect]);

  return { connect };
};
